import React from "react"
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  Image,
  Dimensions,
  ActivityIndicator
} from "react-native"
import Modal from "modal-enhanced-react-native-web"
import moment from "moment"
import IssueSummarySection from "./IssueSummarySection"

const { width } = Dimensions.get("window")

interface Props {
  open: boolean
  issue: any
  onClose: () => void
  onSummarize: (issue: any) => void,
  loader:boolean
}

export default function IssueDetailsModal({
  open,
  issue,
  onClose,
  onSummarize,
  loader
}: Props) {
  if (!issue) return null

  return (
    <Modal
      isVisible={open}
      backdropTransitionInTiming={200}
      backdropTransitionOutTiming={200}
      useNativeDriver={false}
      style={{ margin: 0 }}
    >
      <View style={styles.overlay}>
        <View style={styles.container}>

          {/* HEADER */}
          <View style={styles.header}>
            <Text style={styles.headerTitle}>Issue Details</Text>
          </View>

          <ScrollView
            contentContainerStyle={styles.content}
            showsVerticalScrollIndicator={false}
          >
            <View style={styles.row}>
              <View style={styles.col}>
                <Text style={styles.label}>Title:</Text>
                <Text style={styles.value}>{issue?.title || "—"}</Text>
              </View>

              <View style={styles.col}>
                <Text style={styles.label}>Date:</Text>
                <Text style={styles.value}>
                  {moment(issue?.date_opened).format("DD/MM/YYYY")}
                </Text>
              </View>
            </View>

            <View style={styles.row}>
              <View style={styles.col}>
                <Text style={styles.label}>Category:</Text>
                <Text style={styles.value}>
                  {issue?.open_flow_maintenance_issue_category?.name || "—"}
                </Text>
              </View>

              <View style={styles.col}>
                <Text style={styles.label}>Room Type:</Text>
                <Text style={styles.value}>
                  {issue?.open_flow_maintenance_issue_room_type?.name || "—"}
                </Text>
              </View>
            </View>

            <View style={{ marginTop: 20 }}>
              <Text style={styles.label}>Description:</Text>
              <Text style={styles.value}>{issue?.description || "—"}</Text>
            </View>

            <View style={{ marginTop: 20 }}>
              <Text style={styles.label}>Reported By:</Text>
              <Text style={styles.value}>
                {issue?.user?.first_name} {issue?.user?.last_name}
              </Text>
              <Text style={styles.subValue}>
                {issue?.user?.email}
              </Text>
            </View>

            {/* IMAGES */}
            <View style={{ marginTop: 30 }}>
              <Text style={styles.label}>Annexes:</Text>

              {issue?.images?.length ? (
                <View style={styles.imageGrid}>
                  {issue.images.map((img: string, index: number) => (
                    <Image
                      key={index}
                      source={{ uri: img }}
                      style={styles.image}
                      resizeMode="cover"
                    />
                  ))}
                </View>
              ) : (
                <View style={styles.noImageBox}>
                  <Text style={{ color: "#888" }}>
                    No attachments added
                  </Text>
                </View>
              )}
            </View>
            {issue?.summary? <IssueSummarySection summary={issue?.summary} />:null}
          </ScrollView>

          {/* FOOTER */}
     

          <View style={styles.footer}>
          {issue?.summary? null: <TouchableOpacity
              style={styles.summarizeButton}
              onPress={() => onSummarize(issue)}
              disabled={issue?.summary}
            >
              {loader?<ActivityIndicator color={"white"}/>:
              <Text style={styles.summarizeText}>
                SUMMARIZE ISSUE
              </Text>}
            </TouchableOpacity>}

            <TouchableOpacity onPress={onClose}>
              <Text style={styles.closeText}>CLOSE</Text>
            </TouchableOpacity>
          </View>

        </View>
      </View>
    </Modal>
  )
}

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center"
  },

  container: {
    width: width > 1000 ? 900 : "95%",
    maxHeight: "92%",
    backgroundColor: "#fff",
    borderRadius: 16,
    overflow: "hidden"
  },

  header: {
    padding: 20,
    borderBottomWidth: 1,
    borderColor: "#eee"
  },

  headerTitle: {
    fontSize: 20,
    fontWeight: "600",
    color: "#333"
  },

  content: {
    padding: 25
  },

  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20
  },

  col: {
    flex: 1
  },

  label: {
    fontSize: 14,
    color: "#888",
    marginBottom: 6
  },

  value: {
    fontSize: 16,
    color: "#374151",
    fontWeight: "500"
  },

  subValue: {
    fontSize: 14,
    color: "#6B7280"
  },

  imageGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 15,
    marginTop: 10
  },

  image: {
    width: 140,
    height: 140,
    borderRadius: 10
  },

  noImageBox: {
    marginTop: 10,
    padding: 30,
    borderWidth: 1,
    borderColor: "#ddd",
    borderStyle: "dashed",
    borderRadius: 12,
    alignItems: "center"
  },

  footer: {
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    padding: 20,
    borderTopWidth: 1,
    borderColor: "#eee",
    gap: 20
  },

  summarizeButton: {
    backgroundColor: "#8B5CF6",
    paddingHorizontal: 30,
    paddingVertical: 14,
    borderRadius: 12
  },

  summarizeText: {
    color: "#fff",
    fontWeight: "600",
    letterSpacing: 1
  },

  closeText: {
    color: "#8B5CF6",
    fontWeight: "600",
    fontSize: 16
  }
})
